import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareChecklist: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSquareChecklist"><Path fillRule="evenodd" clipRule="evenodd" d="M3 21V3H21V21H3ZM11.5896 7.60224L10.3896 6.70224L8.49366 9.23016L7.33496 8.45769L6.50291 9.70577L8.84227 11.2653L11.5896 7.60224ZM13.058 8.25V9.75H17.058V8.25H13.058ZM11.5896 13.6034L10.3896 12.7034L8.49366 15.2313L7.33496 14.4588L6.50291 15.7069L8.84227 17.2665L11.5896 13.6034ZM13 14.25V15.75H17V14.25H13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareChecklist;
